import type { HelpFile } from '../../types/help'
import { AppTestIds } from '../../../testids/AppTestIds'

export const appHelp: HelpFile = {
  texts: {
    [AppTestIds.appConfigLoading]: null,
    [AppTestIds.pageH1]: null,
    [AppTestIds.placeholderPageTitle]: null,
  },
}
